var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 opening-postParams"},[_vm._m(0),_c('questions-management',{staticClass:"mt-3",attrs:{"form-id":_vm.boardId,"questions":_vm.postParams,"is-board":""}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h5',[_vm._v(" Questions ")])])
}]

export { render, staticRenderFns }